import React, { useState } from "react";
import axios from "axios";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { API_URL } from "./config";

//const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api";

export default function WifiLoginPage() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token");

  const [loginType, setLoginType] = useState("STUDENT");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState({ type: "", text: "" });

  const handleLogin = async () => {
    setMsg({ type: "", text: "" });

    if (!token) {
      setMsg({ type: "error", text: "Invalid WiFi login session." });
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(`${API_URL}/api/captive-portal/login`, {
        token,
        loginType,
        username,
        password,
        mobileNumber,
        otp,
      });

      setMsg({ type: "success", text: res.data.message || "WiFi access granted" });

      setTimeout(() => {
        window.location.href = res.data.redirectUrl || "https://www.google.com";
      }, 1200);
    } catch (err) {
      setMsg({
        type: "error",
        text: err.response?.data?.error || "Unable to login to WiFi",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      minHeight="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgcolor="#f5f7fb"
      px={2}
    >
      <Card sx={{ width: "100%", maxWidth: 430, borderRadius: 4 }}>
        <CardContent>
          <Stack spacing={2.2}>
            <Box textAlign="center">
              <Typography variant="h5" fontWeight={800}>
                UniFLOO WiFi Login
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Login to continue using campus internet
              </Typography>
            </Box>

            {msg.text && <Alert severity={msg.type}>{msg.text}</Alert>}

            <TextField
              select
              label="Login Type"
              value={loginType}
              onChange={(e) => setLoginType(e.target.value)}
              fullWidth
            >
              <MenuItem value="STUDENT">Student</MenuItem>
              <MenuItem value="STAFF">Staff</MenuItem>
              <MenuItem value="VISITOR">Visitor</MenuItem>
            </TextField>

            {loginType !== "VISITOR" && (
              <>
                <TextField
                  label={loginType === "STUDENT" ? "Student ID" : "Username"}
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  fullWidth
                />

                <TextField
                  label="Password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  fullWidth
                />
              </>
            )}

            {loginType === "VISITOR" && (
              <>
                <TextField
                  label="Mobile Number"
                  value={mobileNumber}
                  onChange={(e) => setMobileNumber(e.target.value)}
                  fullWidth
                />

                <TextField
                  label="OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  fullWidth
                />
              </>
            )}

            <Button
              variant="contained"
              size="large"
              onClick={handleLogin}
              disabled={loading}
              sx={{ borderRadius: 2, py: 1.2 }}
            >
              {loading ? <CircularProgress size={24} /> : "Connect to WiFi"}
            </Button>

            <Typography variant="caption" color="text.secondary" textAlign="center">
              By continuing, you agree to campus internet usage policies.
            </Typography>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}